export const HEADER_HEIGHT = 64;
export const SIDEBAR_WIDTH = 180;
export const PAGE_WIDTH_NO_SIDEBAR = 1024;
